import { Breadcrumbs } from '@mui/material';
import React from 'react';
import Link from '@mui/material/Link';
import { Link as RouterLink, useLocation, } from 'react-router-dom';

const breadcrumbNameMap = {
    '/questdesigner': 'Quest Designer',
    '/questdesigner/quest': 'Quests',
    '/questdesigner/character': 'Characters',
    '/questdesigner/group': 'Story Groups',
    '/questdesigner/placeholder': 'Placeholders',
    '/fasttravel': 'Fast Travel',
    '/fasttravel/group': 'Groups',
    '/fasttravel/point': 'Points',
    '/joinleavemessage': 'Join & Leave Messages',
    '/salesbarn': 'Sales Barn',
    '/discord': 'Discord Bot',
    '/discord/server': 'Servers',
    '/university': 'University',
    '/university/degree': 'Degrees',
    '/university/module': 'Modules',
    '/university/book': 'Books',
    '/university/house': 'Houses',
    '/discipline': 'Disciplines',
    '/attribute': 'Attributes',
    '/attribute/horse': 'Horses',
    '/attribute/player': 'Players',
    '/spawnpoint': 'Spawn Points',
    '/skill': 'Skills',
    '/illness': 'Illnesses',
    '/illnesssymptom': 'Illness Symptoms',
    '/weather': 'Weather',
    '/operation': 'Operation',
    '/horse': 'Horse',
    '/horse/tack': 'Tack',
    '/horse/tack/bonnet': 'Bonnets',
    '/horse/tack/boots': 'Boots',
    '/horse/tack/bridle': 'Bridles',
    '/horse/tack/cinch': 'Cinches',
    '/horse/tack/girth': 'Girths',
    '/horse/tack/halter': 'Halters',
    '/horse/tack/pad': 'Pads',
    '/horse/tack/rein': 'Reins',
    '/horse/tack/saddle': 'Saddles',
    '/horse/tack/wraps': 'Wraps',
    '/bulletin': 'Bulletins',
    '/behaviour': 'Behaviour',
    '/business': 'Businesses',
    '/business/category': 'Categories',
    '/chattag': 'Chat Tags',
    '/shop': 'Shops',
    '/collectable': 'Collectables',
    '/collectable/group': 'Groups',
    '/collectable/item': 'Items',
    '/studregistry': 'Stud Registries',
    '/job': 'Jobs',
    '/breed': 'Breeds',
    '/breed/breed': 'Breeds',
    '/breed/group': 'Groups',
    '/blood': 'Blood',
    '/blood/age': 'Age Settings',
    '/warning': 'Warnings',
    '/warning/reason': 'Reasons',
    '/warning/warning': 'Review Warnings',
    '/registrationorganization': 'Registration Organizations',
    '/user': 'Users',
    '/npc': 'NPC',
    '/economy': 'Economy',
    '/discoverlocation': 'Discover Locations',
    '/conformation': 'Conformation',
    '/conformation/measurement': 'Measurement',
    '/leaderboard': 'Leaderboards',
    '/log': 'Logs',
    '/dailyjoinreward': 'Daily Join Rewards',
    '/dashboardrole': 'Dashboard Roles',
    '/website': 'Website',
    '/website/announcement': 'Announcements',
    '/website/pagetext': 'Page Text',
    '/website/application': 'Applications',
    '/website/application/type': 'Types',
    '/admin': 'Admin',
    '/allele': 'Alleles',
    '/nutrient': 'Nutrients',
    '/horsebit': 'Horse Bits',
    '/horseshoe': 'Horse Shoes',
    '/faction': 'Factions',
    '/playerrank': 'Player Ranks',
    '/blood/type': 'Types',
    '/player': 'Player',
    '/player/import': 'Import',
    '/agesetting': 'Age Setting',
    '/navigator': 'Navigator',
    '/player/report': 'Reports',
    '/horsecreate': 'Horse Create',
    '/preset-build': 'Preset Builds',
    '/preset-build/build': 'Builds',
    '/preset-build/order': 'Orders',
    '/floating-text': 'Floating Text',
    '/roadmap': 'Roadmap',
    '/badge': 'Badges',
    '/website/link': 'Links',
    '/provision': 'Provisions',
    '/medicine': 'Medicine',
    '/medicineoverdosegroup': 'Medicine Overdose Groups',
    '/supplement': 'Supplements',
    '/credit': 'Credits',
};

function LinkRouter(props) {
    return <Link {...props} component={RouterLink} />;
}

export default function BreadcrumbTrail() {
    const location = useLocation();
    const pathnames = location.pathname.split('/').filter((x) => x);
    if (pathnames.length === 1) {
        return null;
    }
    return (
        <Breadcrumbs separator='>' sx={{
            paddingLeft: '5px',
            paddingRight: '5px',
        }}>
            {pathnames.map((value, index) => {
                const last = index === pathnames.length - 1;
                const to = `/${pathnames.slice(0, index + 1).join('/')}`;

                return last ? (
                    null
                ) : (
                    <LinkRouter underline="hover" color="inherit" to={to} key={to}>
                        {breadcrumbNameMap[to] || null}
                    </LinkRouter>
                );
            })}
        </Breadcrumbs>
    );
};